import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const ErrorIntroComponent = React.lazy(() => import("../Components/RootComponents/ErrorIntroComponent"));
const ErrorIntroPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ErrorIntroComponent />
      </Suspense>
    </Fragment>
  );
};

export default ErrorIntroPage;
